import { Routes } from '@angular/router';
import { AnonymousComponent } from './anonymous.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { UnsubscribedComponent } from './unsubscribed/unsubscribed.component';

export const AnonymousRoutes: Routes = [
  {
    path: '',
    component: AnonymousComponent,
    children: [
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
      },
      {
        path: 'terms-and-conditions',
        component: TermsOfServiceComponent,
      },
      {
        path: 'unsubscribed',
        component: UnsubscribedComponent,
      },
    ],
  },
];
